import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';

import { DataTableModule } from 'angular-4-data-table-bootstrap-4';

import { SharedModule } from '../../shared.module';
import { UscCamaignComponent } from './usc-campaign.component';
import { UsciHomeComponent } from './usci-home/usci-home.component';
import { UsciHeaderComponent } from './usci-header/usci-header.component';
import { UscCampaignService } from '../../services/usc-campaign/usc-campaign.service';

const UscCampaignRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'usc-campaign/home',
    component: UsciHomeComponent,
  }, 
]);

@NgModule({
  exports: [
  ],
  imports: [
    NgbDropdownModule.forRoot(),
    UscCampaignRouting, 
    SharedModule,
    DataTableModule,
    NgxMaskModule.forRoot(),
  ],
  declarations: [
    UscCamaignComponent,
    UsciHeaderComponent,
    UsciHomeComponent,
  ],
  providers: [
    UscCampaignService,
    NgbModal,
    NgbActiveModal,
  ],
  // add components here for dynamic loading
  entryComponents: [ 
    // FieldComponent
  ]
})

export class UscCampaignModule {}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-campaign/usc-campaign.module.ts